var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"not-found"}},[_c('p',{staticClass:"text"},[_c('span',[_vm._v("404 Not Found")]),_c('button',{on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("Go to Homepage")])])])}
var staticRenderFns = []

export { render, staticRenderFns }